import React from 'react';
import {Icons, Images} from '../../assets';
import {Strings} from '../../constants';
import Logger from '../../logger';
import {AnalyticsService} from '../../services';
import {isMobile} from '../../utils';
import './styles.scss';

type Props = {
  reccoId?: string;
  showShareBtn?: boolean;
  title?: string;
};

export const ReccoSidebar: React.FC<Props> = ({reccoId, showShareBtn, title}) => {
  const shareRecco = async (): Promise<void> => {
    try {
      if (isMobile() && shareSupported) {
        navigator.share({
          title: Strings.SHARE_RECCO_TEXT,
          text: Strings.SHARE_RECCO_TEXT,
          url: window.location.href,
        });
      } else {
        // copy to clipboard
        navigator.clipboard.writeText(window.location.href).then(() => alert('Link copied to clipboard'));
      }
      AnalyticsService.track('Recco Forward', {
        reccoId,
        timestamp: Date.now(),
        medium: 'PUBLIC',
      });
    } catch (e) {
      Logger.log(e.toString());
    }
  };

  const shareSupported = window?.navigator?.share !== undefined;

  return (
    <div className="reccoSidebar mb-4">
      <div className="mb-3 benefitsHeading">{title}</div>
      {[
        {text: Strings.GROW_FAM, icon: Icons.FAM},
        {text: Strings.GREAT_PERKS, icon: Icons.PERK},
        {text: Strings.RECCO_TO_FAM, icon: Icons.RECCO},
      ].map((item, index) => (
        <div key={index} className="benefit clearfix d-flex align-items-center">
          <img src={item.icon} alt="icon" className="icon listIcon" />
          <p className="listText">{item.text}</p>
        </div>
      ))}
      {showShareBtn && (!isMobile() || shareSupported) && (
        <><div className="btn btn-primary w-100  mt-4" role="button" onClick={shareRecco}>
          {Strings.SHARE_THIS_RECCO}
        </div>
        <div className="w-100 h-100 mt-3 d-flex justify-content-between">
            <a
              className="sidebar-app-btn w-100"
              href={process.env.REACT_APP_RECCO_PLAY_STORE_URL}
              target="_blank"
              rel="noreferrer">
              <img src={Images.PLAY_STORE} className="w-100" alt="Play Store" />
            </a>
            <a
              className="sidebar-app-btn w-100"
              href={process.env.REACT_APP_RECCO_APP_STORE_URL}
              target="_blank"
              rel="noreferrer">
              <img src={Images.APPLE_STORE} className="w-100" alt="Apple Store" />
            </a>
          </div>
        </>
        
        
      )}
      <a
        className="my-3 d-flex align-items-center flex-column link"
        target="_blank"
        rel="noreferrer"
        href={process.env.REACT_APP_RECCO_MARKETING_URL}>
        {Strings.TELL_ME_MORE_ABOUT_RECCO}
      </a>
      {showShareBtn && !isMobile() && <img src={Images.SHARE_RECCO_BANNER} className="w-100 mt-5 pt-5" alt="share" />}
    </div>
  );
};

ReccoSidebar.defaultProps = {
  showShareBtn: false,
  title: Strings.JOIN_FAM_TITLE,
};
